import React, { useEffect, useState } from "react";
import Card from "../Dashboard/Card/Card";
import Header from "../../../Components/Header";
import "../Dashboard/index.scss";
import { BASE_DOMAIN, columns} from "../../../utils/constants";
import ApartmentIcon from "@mui/icons-material/Apartment";
import DescriptionIcon from "@mui/icons-material/Description";
import DynamicTable from "../../../Components/Table";
import CommonModal from "../../../Components/Modals/index";
import { useDeleteCompanyMutation, useFetchcompanyQuery, useToggleCompanyMutation } from "../../../features/Group/groupSlice";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { DeleteOutlineOutlinedIcon, EditOutlinedIcon, ToggleOffOutlinedIcon } from "../../../utils/icons";
import YearFilter from "../../../Components/YearFilter/YearFilter";
import { useGetdashQuery } from "../../../features/Dashboard/dashboardSlice";

const DashboardSub = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [dropdown, setDropdown] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [row, setRow] = useState({});
  const [filters, setFilters] = useState([]);

  const { data: Dashdata = { data: [] }, error: dashErr, isLoading: dashLoad } = useGetdashQuery({ year: filters, groupId: JSON.parse(localStorage.getItem("group")) });
  const [modalData, setModalData] = useState({
    title: "",
    description: "",
    icon: "",
  });
  const [modal, setModal] = useState(false);
  const dynamicUrl = `${BASE_DOMAIN}companies/${JSON.parse(localStorage.getItem("group"))}`;
  const {
    data = { data: [] },
    error,
    isLoading,
    refetch,
  } = useFetchcompanyQuery({
    url: dynamicUrl, // Replace with the base endpoint URL
    filters: { page: 1 },
  });
  const queryParams = new URLSearchParams(location.search);
    const [deleteCompany, { isLoading: delLoading, isSuccess, error: anyError }] = useDeleteCompanyMutation();
    const [toggleCompany, { isLoading: toggleLoading, isSuccess: togSuccess, isError }] = useToggleCompanyMutation();
  const id = queryParams.get("id");

  useEffect(() => {
    console.log("Filters updated:", filters);
    refetch();
  }, [location.pathname, filters]);


  const handleRowValue = (val) => {
    setRow(val);
    if (val.status === "Inactive") {
      setDropdown([
        {
          name: "Edit Company",
          icon: <EditOutlinedIcon />,
          id: 1,
        },
        {
          name: "Delete Company",
          icon: <DeleteOutlineOutlinedIcon />,
          id: 2,
        },
        {
          name: "Make Group Active",
          icon: <ToggleOffOutlinedIcon />,
          id: 3,
        },
      ]);
    } else {
      setDropdown([
        {
          name: "Edit Company",
          icon: <EditOutlinedIcon />,
          id: 1,
        },
        {
          name: "Delete Company",
          icon: <DeleteOutlineOutlinedIcon />,
          id: 2,
        },
        {
          name: "Make Group Inactive",
          icon: <ToggleOffOutlinedIcon />,
          id: 3,
        },
      ]);
    }
  };

  const handleMenuItem = (val) => {
    if (val.id === 1) {
      navigate({
        pathname: "/sub/company/add-company",
        search: `?${createSearchParams({ id: id, isupdate: true, compid: row.id })}`,
      });
    }
    if (val.id === 2) {
      setModalData({
        title: "Delete Company",
        description: "Are you sure you want to delete this company?",
        icon: true,
      });

      setModal(true);
    }
    if (val.id === 3) {
      setModalData({
        title: row.status === "Inactive" ? "Make Group Active" : "Make Group Inactive",
        description: row.status === "Inactive" ? "Are you sure you want to make group active?" : "Are you sure you want to make group inactive?",
        icon: false,
      });

      setModal(true);
    }
  };

  const handleConfirmAction = async () => {
    try {
      if (modalData.title === "Delete Company") {
        const result = await deleteCompany(row.id).unwrap();
        refetch();
      } else {
        const result = await toggleCompany(row.id).unwrap();
        refetch();
      }
    } catch (err) {}
    setModal(false);
  };

  const handleSort = () => {
    setFilters({
      ...filters,
    });
  };

  const cardsArr = [
    // {
    //   icon: <GroupsIcon className='dashboard_card_icon' />,
    //   text: "Total number of groups",
    //   groups: 250,
    //   backgroundColor: "#493D9E",
    // },
    {
      icon: <ApartmentIcon className='dashboard_card_icon' />,
      text: "Total Number Of Companies",
      groups: Dashdata?.companyCount || 0,
      backgroundColor: "#8E1FB4",
    },
    {
      icon: <DescriptionIcon className='dashboard_card_icon' />,
      text: "Total Records Added",
      groups: Dashdata?.inputLayoutCount || 0,
      backgroundColor: "#48A6A7",
    },
  ];

  const handleFilter = (data) => {
    // console.log("DATAAA",data)
    const numArray = data.map(Number);
    setFilters(numArray)

  }

  const handlePageChange = (page) => {
    setFilters({
      ...filters,
      page: page,
    });
    setCurrentPage(page);
  };

  const handleChangeRowsPerPage = (event) => {
    console.log("vv", parseInt(event.target.value, 10));
    setRowsPerPage(parseInt(event.target.value, 10));
    const newLimit = parseInt(event.target.value, 10);
    setFilters((prevFilters) => ({
      ...prevFilters,
      limit: newLimit,
      page: 1, // Reset to the first page whenever rows per page changes
    }));
    setCurrentPage(1); // Reset to the first page whenever rows per page changes
  };

  const handleReset = () => {
    setFilters([])
  }

  const handleShowMoreClick = () => {
    console.log("first");
    navigate("/sub/report");
  };

  return (
    <>
      <div className='dashboard_container'>
        {/* <div className='dashboard_header'>
          <Header
            title='Dashboard Design'
            description='Here, you can Check and review the dashbaord'
            // searchValue={searchValue}
            // isSearchDisable={true}
            btnText='Add Group'
            isSearchField={false}
            // searchText='Search by Company Name'
            isIcon={false}
            isYear={true}
            isFilter={true}
            isback={false}
            isBtn={false}
          />
        </div> */}
        <div className='dashboard_body'>
          <div className='dashboard_cards_filter'>
            <div className='dashboard_cards'>
              {cardsArr.map((card, index) => (
                <Card key={index} icon={card.icon} text={card.text} groups={card.groups} bgcolor={card.backgroundColor} />
              ))}
            </div>
            <YearFilter onFilterClick={handleFilter} onReset={handleReset} />
          </div>
          <div className='dashboard_body_table'>
            <Header
              title={"Latest Companies Added"}
              description={`${data?.data.length} Companies`}
              isSearchField={false}
              isCancel={false}
              // btnText={"Add Data"}
              // btnLoading={false}
              isIcon={false}
              isBtn={false}
            // onAction1Click={handleAdd}
            // handleCancel={handleCancelClick}
            />

            <DynamicTable
              columns={columns}
              rows={data?.data}
              isLoading={isLoading}
              onClick={handleSort}
              total={Math.ceil(data?.total / 10)}
              dropMenuList={dropdown}
              currentPage={currentPage}
              handleAction={handleRowValue}
              handleMenu={handleMenuItem}
              isDash={true}
              isFooter={false}
              // page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

            {modal && (
                    <CommonModal
                      setIsOpenPopUp={setModal}
                      open={modal}
                      isLoading={delLoading || toggleLoading}
                      handleDelete={handleConfirmAction}
                      item={{
                        title: modalData.title,
                        description: modalData.description,
                        icon: modalData.icon,
                      }}
                    />
                  )}
            {/* <DynamicTable
              columns={columns}
              rows={data?.data}
              isLoading={isLoading}
              // onClick={handleSort}
              dropMenuList={dropdown}
              handleAction={handleRowValue}
              handleMenu={handleMenuItem}
              isFooter={false}
              isDash={true}
            /> */}

            {/* <button className='show_more' onClick={handleShowMoreClick}>
              See More
              <ChevronRightIcon className='right_icon' />
            </button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardSub;
